import { format } from 'date-fns';
import { DAY_PRESETS, RANGE_PRESETS } from '../../constants';
import { FilterData } from '../../components/FilterForm/FilterForm';
import { TranslateFn } from '../../hooks/context/useTranslate';

export const getDateFilterValuesLabel = (
  filterData: FilterData | undefined,
  filterType: string,
  translate: TranslateFn
) => {
  let dateText;
  if (filterData?.namedRange) {
    const presets =
      filterType === 'DATE' ? DAY_PRESETS : (RANGE_PRESETS as any);
    const preset = presets.find(({ id }) => id === filterData.namedRange);
    if (preset) {
      dateText = translate(preset.name);
    }
  } else if (
    filterType === 'DATE' &&
    filterData?.values &&
    filterData.values[0]
  ) {
    dateText = format(new Date(filterData.values[0]), 'd. M. yyyy');
  } else if (
    filterType === 'DATERANGE' &&
    filterData?.values &&
    filterData.values[0] &&
    filterData.values[1]
  ) {
    const from = format(new Date(filterData.values[0]), 'd. M. yyyy');
    const to = format(new Date(filterData.values[1]), 'd. M. yyyy');
    if (from === to) {
      dateText = from;
    } else {
      dateText = `${from} - ${to}`;
    }
  }
  return dateText;
};
